module.exports = __webpack_public_path__ + "img/appDB.e861eb8f.svg";